import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Convert an image_url from /api/... to an absolute URL using REACT_APP_BACKEND_URL
export function absoluteImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Admin token helpers.
//
// Trade-off note: this site is a single-admin marketing/lead-gen frontend.
// We deliberately keep the JWT in localStorage because:
//   1) Simple to reason about and doesn't require cross-origin cookie plumbing.
//   2) The blast radius of a hypothetical XSS is limited to the admin's own
//      photo-upload UI (no financial actions, no PII beyond phone numbers).
//   3) The integration playbook used for this auth also uses this pattern.
// If the scope grows (payments, customer accounts) we should switch to
// httpOnly cookies with SameSite=Lax + CSRF.
const TOKEN_KEY = "bm_admin_token";
/* eslint-disable no-restricted-globals -- localStorage is intentional here; see block comment above. */
export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);
/* eslint-enable no-restricted-globals */

export function authHeaders() {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const api = axios.create({ baseURL: API });
